import jalaali from "jalaali-js";

import dayjs from 'dayjs'
import jalaliday from 'jalaliday'

export const convertToJalali = (gregorianDate) => {
    const [datePart, timePart] = gregorianDate.split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const jalaliDate = jalaali.toJalaali(year, month, day);
    const time = timePart ? timePart.split(":").slice(0, 2).join(":") : "00:00";
    return `${time} - ${jalaliDate.jy}/${jalaliDate.jm}/${jalaliDate.jd}`;
  };
export const convertToJalaliNoTime = (gregorianDate) => {
    const [datePart] = gregorianDate.split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const jalaliDate = jalaali.toJalaali(year, month, day);
    return `${jalaliDate.jy}/${jalaliDate.jm}/${jalaliDate.jd}`;
  };


dayjs.extend(jalaliday)

// @ts-ignore
dayjs.calendar('jalali') 
export default dayjs
